import { CHANGE_LOCALE, SET_URGET_MODAL } from '../constants';

export function changeLocale(languageLocale) {
  return {
    type: CHANGE_LOCALE,
    locale: languageLocale,
  };
}
export function setUrgentModal() {
  return {
    type: SET_URGET_MODAL
  };
}